import React from 'react';
import clsx from 'clsx';
import whoopLoading from '../../assets/whoop-loading.gif';
import darkModeLoading from '../../assets/whoop-loading-dark-mode.gif';
export type LoadingVariants = 'primary' | 'dark';
export type LoadingSizeType = 'small' | 'medium' | 'large';
const variantToLogo = {
  primary: whoopLoading,
  dark: darkModeLoading
};
export interface LoadingProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: LoadingSizeType;
  variant?: LoadingVariants;
  containerStyling?: string;
}
const sizeClasses = {
  small: 'w-8 h-8 -ml-4 -mt-4',
  medium: 'w-12 h-12 -ml-6 -mt-6',
  large: 'w-16 h-16 -ml-8 -mt-8'
};
export function Loading({
  size = 'medium',
  className,
  variant = 'primary',
  ...props
}: LoadingProps) {
  return <img alt='Loading' className={clsx('pointer-events-none absolute left-1/2 top-1/2 z-[951] block', sizeClasses[size], className)} data-testid='loading-indicator' src={variantToLogo[variant].src} {...props} data-sentry-component="Loading" data-sentry-source-file="Loading.tsx" />;
}